import { Alert, Button, Snackbar, Stack, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetPatientWeightsQuery } from "src/api/services/weightTrackerApi";
import NewWeightModal from "src/shared/components/NewWeightModal";
import WhiteCard from "src/shared/components/WhiteCard";
import WeightProgress from "./components/WeightProgress";
import Measurements from "./Measurements";
import TrackerCoupon from "./components/WeightProgress/TrackerCoupon";

const WeightTracker = () => {
  const { data = [] } = useGetPatientWeightsQuery();
  const { t } = useTranslation();
  const component = "weight-tracker";
  const [open, setOpen] = useState<boolean>(false);
  const [display, setDisplay] = useState<boolean>(false);

  const measurements = useMemo(() => {
    if (data.length === 0) return null;

    const height = data[0].height ?? "N/A";
    const starting = data[data.length - 1].weight ?? "N/A";
    let current: number | null = null;

    if (data.length > 1) {
      current = data[0].weight;
    }

    return { starting, current, height };
  }, [data]);

  if (measurements == null) {
    return null;
  }
  return (
    <>
      <WhiteCard>
        <Typography fontWeight={600}>
          {t(`${component}.header`, "Weight Tracking")}
        </Typography>
        <Stack gap={1.4}>
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Measurements measurements={measurements} />
            <Button sx={{ p: 3 }} onClick={() => setOpen((o) => !o)}>
              {t(`${component}.log-button`, "Log")}
            </Button>
          </Stack>
          {measurements.current ? (
            <WeightProgress measurements={measurements} />
          ) : null}
        </Stack>
        <TrackerCoupon />
      </WhiteCard>
      <NewWeightModal
        open={open}
        onClose={setOpen}
        height={measurements.height}
        setDisplay={setDisplay}
      />
      <Snackbar
        open={display}
        autoHideDuration={4000}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        onClose={() => setDisplay(false)}
      >
        <Alert sx={{ width: "100%" }} onClose={() => setDisplay(false)}>
          {t(`${component}.success`, "New weight logged")}
        </Alert>
      </Snackbar>
    </>
  );
};

export default WeightTracker;
